// @flow

import type { CountryCode } from '../types/country-code'
import { COUNTRY_CODE_NLD } from '../types/country-code'

export type BaseAddress = {
  postcode: ?string,
  city: ?string,
  countryCode: ?CountryCode
}

const buildBaseAddress = (): BaseAddress => {
  return {
    postcode: '',
    city: '',
    countryCode: COUNTRY_CODE_NLD
  }
}

export {
  buildBaseAddress
}



// WEBPACK FOOTER //
// ./src/types/base-address.js